export *from './menuitem.component';
export *from './report.component';


// WEBPACK FOOTER //
// ./app/insa-report/index.ts